var debug = false;

var lazyConfig = {
	root: null,
	rootMargin: '200px'
};
lazyLoadInit(lazyConfig);
lazyLoadBackgroundInit(lazyConfig);

